import { Reveal } from "./Reveal";

export const SectionHead = ({ chapter, eyebrow, title, lead, dark = false }) => (
  <div className="max-w-3xl">
    <Reveal>
      <div className="flex items-center gap-4 mb-7">
        <span className={`font-mono text-xs font-semibold tracking-[0.18em] ${dark ? "text-[#6D8FF0]" : "text-[#024AD8]"}`}>
          {chapter}
        </span>
        <span className={`h-px w-12 ${dark ? "bg-[#6D8FF0]/40" : "bg-[#024AD8]/40"}`} />
        <span className={`font-mono text-xs uppercase tracking-[0.18em] font-semibold ${dark ? "text-slate-400" : "text-slate-500"}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] ${dark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
    </Reveal>
    {lead && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>
          {lead}
        </p>
      </Reveal>
    )}
  </div>
);
